import React, { useCallback, useEffect, useState } from "react";
import "../leaveHistory.css";
import DashboardGreeting from "../DashboardGreeting";
import moment from "moment";

import DashedArrow from "../../assets/images/dashed-arrow2.svg";
import PartiallyApprovedDashedArrow from "../../assets/images/partiallyApprovedDashedArrow2.svg";
import ApprovedDashedArrow from "../../assets/images/approvedDashedArrow2.svg";
import partiallyRejectedDashedArrow from "../../assets/images/partiallyRejectedDashedArrow2.svg";
import RejectedDashedArrow from "../../assets/images/rejectedDashedArrow2.svg";

import TeamLead from "../../assets/images/teamlead.png";
import TimeIcon from "../../assets/images/time.svg";
import GreenCheck from "../../assets/images/greenCheck.svg";
import RedCross from "../../assets/images/close-circle.svg";
import { useLocation } from "react-router-dom";
import LeaveHistoryService from "../../services/leaveHistory.service";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Form } from "react-bootstrap";
import HolidayShiftService from "../../services/holidayshift.service";
import { useStateContext } from "../../contexts/ContextProvider";

const HolidayShiftDetails = ({ user }) => {
  const navHeading = "Holiday Shift Details";

  const location = useLocation();

  const { rowData, leaveCat, redirectBack } = location.state || {};

  const { getNameInitials } = useStateContext();

  // console.log("Row Data:", rowData);

  const [modalShow, setModalShow] = useState(false);
  const [validated, setValidated] = useState(false);

  const [updateDetails, setUpdateDetails] = useState({
    wDfromtime: "",
    wDtotime: "",
    requestid: "",
    wdWorkinghrs: "",
    wDdescription: "",
    rdate: "",
  });

  const [approvalStatus, setApprovalStatus] = useState("");
  const [approvalStatusClassName, setApprovalStatusClassName] = useState("");

  const [approvalHierarchy, setApprovalHierarchy] = useState([
    {
      type: "TL",
      empid: "",
      name: "",
    },
    {
      type: "HR",
      empid: "",
      name: "",
    },
  ]);

  useEffect(() => {
    if (rowData) {
      fetchApprovalHierarchy();
    }
  }, [rowData]);

  const fetchApprovalHierarchy = () => {
    const req1 = {
      userId: rowData && rowData.empid,
    };

    LeaveHistoryService.getTeamLeadDetail(req1)
      .then((response) => {
        if (response.data) {
          const data = [...approvalHierarchy];
          data[0].empid = response.data.empid;
          data[0].name = response.data.name;
          setApprovalHierarchy(data);
        }
      })
      .catch((e) => console.log(e));

    const req2 = {
      Empid: user.empid,
    };

    LeaveHistoryService.getHRDetail(req2)
      .then((response) => {
        if (response.data) {
          const data = [...approvalHierarchy];
          data[1].empid = response.data.empid;
          data[1].name = response.data.name;
          setApprovalHierarchy(data);
        }
      })
      .catch((e) => console.log(e));
  };

  // console.log("location.pathname", location.pathname)

  const checkApprovalStatus = useCallback((rowData) => {
    if (rowData) {
      if (rowData.rM_isapproved === "0" && rowData.hR_isapproved === "0") {
        setApprovalStatus("Pending");
        setApprovalStatusClassName("pending");
      } else if (
        rowData.rM_isapproved === "1" &&
        rowData.hR_isapproved === "0"
      ) {
        setApprovalStatus("Approved By RM");
        setApprovalStatusClassName("pending");
      } else if (
        rowData.rM_isapproved === "1" &&
        rowData.hR_isapproved === "1"
      ) {
        setApprovalStatus("Approved");
        setApprovalStatusClassName("approved");
      } else if (
        rowData.rM_isapproved === "2" &&
        rowData.hR_isapproved === "2"
      ) {
        setApprovalStatus("Rejected");
        setApprovalStatusClassName("rejected");
      } else {
        setApprovalStatus(""); // Or some default/error state if needed
      }
    }
  }, []);

  useEffect(() => {
    checkApprovalStatus(rowData);
  }, [checkApprovalStatus]);

  const calculateTimeDifference = (time1, time2) => {
    // console.log(time1, time2);
    time1 = time1 && time1.split(":");
    time2 = time2 && time2.split(":");

    var startDate = new Date(0, 0, 0, time1[0], time1[1], 0);
    var endDate = new Date(0, 0, 0, time2[0], time2[1], 0);

    var diff = endDate.getTime() - startDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);

    if (hours < 0) {
      hours = hours + 24;
    }

    return (
      (hours <= 9 ? "0" : "") +
      hours +
      ":" +
      (minutes <= 9 ? "0" : "") +
      minutes
    );
  };

  const handleShowModal = (date, rid) => {
    setModalShow(true);
    setUpdateDetails((prev) => ({
      ...prev,
      rdate: date,
      requestid: rid,
    }));
  };

  const handleInputChnage = (e) => {
    const { name, value } = e.target;

    if (name === "wDfromtime") {
      const hours = calculateTimeDifference(value, updateDetails.wDtotime);
      setUpdateDetails((prevState) => ({
        ...prevState,
        wDfromtime: value,
        wdWorkinghrs: hours,
      }));
    } else if (name === "wDtotime") {
      const hours = calculateTimeDifference(updateDetails.wDfromtime, value);
      setUpdateDetails((prevState) => ({
        ...prevState,
        wDtotime: value,
        wdWorkinghrs: hours,
      }));
    } else {
      setUpdateDetails((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleUpdateLogs = (e) => {
    const form = e.currentTarget;

    if (updateDetails.wDfromtime === "" && updateDetails.wDtotime === "") {
      toast.warn("Please fill all required fields *!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    const payload = {
      wDfromtime: updateDetails.wDfromtime,
      wDtotime: updateDetails.wDtotime,
      requestid: updateDetails.requestid,
      wdWorkinghrs: updateDetails.wdWorkinghrs,
      wDdescription: updateDetails.wDdescription,
      rdate: updateDetails.rdate,
    };

    HolidayShiftService.updateWorkDone(payload)
      .then((resp) => {
        if (resp.data) {
          toast.success("Log Hours Updated Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setModalShow(false);
        }
      })
      .catch((e) => console.log(e));
  };

  return (
    <>
      <div className="dashboard-container leaveDetails">
        <DashboardGreeting
          navHeading={navHeading}
          redirectBack={redirectBack}
          user={user}
          rowData={rowData}
        />
        <ToastContainer />
        <div className="filterBar mb-5">
          <div className={`status ${approvalStatusClassName}`}>
            <span title={approvalStatus}>{approvalStatus}</span>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8">
            <div className="basic-details">
              <div className="heading">
                <span>Basic Details</span>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="approval-status2 recent-leave">
              <div className="heading">
                <span>Approval Status</span>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8">
            <div className="basic-details">
              <div className="leave-info mb-5">
                <div className="row mb-5">
                  <div className="col-lg-4">
                    <div className="item">
                      <div className="icon">
                        <svg
                          width="48"
                          height="49"
                          viewBox="0 0 60 61"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_1512_21220)">
                            <path
                              d="M18.75 41.75C20.7391 41.75 22.6468 40.9598 24.0533 39.5533C25.4598 38.1468 26.25 36.2391 26.25 34.25C26.25 32.2609 25.4598 30.3532 24.0533 28.9467C22.6468 27.5402 20.7391 26.75 18.75 26.75C16.7609 26.75 14.8532 27.5402 13.4467 28.9467C12.0402 30.3532 11.25 32.2609 11.25 34.25C11.25 36.2391 12.0402 38.1468 13.4467 39.5533C14.8532 40.9598 16.7609 41.75 18.75 41.75ZM18.75 30.5C19.7446 30.5 20.6984 30.8951 21.4017 31.5984C22.1049 32.3016 22.5 33.2554 22.5 34.25C22.5 35.2446 22.1049 36.1984 21.4017 36.9016C20.6984 37.6049 19.7446 38 18.75 38C17.7554 38 16.8016 37.6049 16.0983 36.9016C15.3951 36.1984 15 35.2446 15 34.25C15 33.2554 15.3951 32.3016 16.0983 31.5984C16.8016 30.8951 17.7554 30.5 18.75 30.5ZM28.125 45.5H9.375C6.8886 45.5 4.50403 46.4877 2.74587 48.2459C0.98772 50.004 0 52.3886 0 54.875C0 56.3668 0.592635 57.7976 1.64753 58.8525C2.70242 59.9074 4.13316 60.5 5.625 60.5H31.875C33.3668 60.5 34.7976 59.9074 35.8525 58.8525C36.9074 57.7976 37.5 56.3668 37.5 54.875C37.5 52.3886 36.5123 50.004 34.7541 48.2459C32.996 46.4877 30.6114 45.5 28.125 45.5ZM31.875 56.75H5.625C5.12772 56.75 4.6508 56.5525 4.29917 56.2008C3.94754 55.8492 3.75 55.3723 3.75 54.875C3.75 53.3832 4.34264 51.9524 5.39753 50.8975C6.45242 49.8426 7.88316 49.25 9.375 49.25H28.125C29.6168 49.25 31.0476 49.8426 32.1025 50.8975C33.1574 51.9524 33.75 53.3832 33.75 54.875C33.75 55.3723 33.5525 55.8492 33.2008 56.2008C32.8492 56.5525 32.3723 56.75 31.875 56.75ZM60 9.875V28.625C60 31.1114 59.0123 33.496 57.2541 35.2541C55.496 37.0123 53.1114 38 50.625 38H40.1512L33.2025 44.9525C33.0281 45.1265 32.821 45.2644 32.5932 45.3584C32.3655 45.4523 32.1214 45.5004 31.875 45.5C31.6292 45.5006 31.3857 45.4522 31.1588 45.3575C30.8159 45.2158 30.5227 44.9755 30.3165 44.6671C30.1102 44.3587 30.0001 43.996 30 43.625V36.125C30 35.6277 30.1975 35.1508 30.5492 34.7992C30.9008 34.4475 31.3777 34.25 31.875 34.25C32.3723 34.25 32.8492 34.4475 33.2008 34.7992C33.5525 35.1508 33.75 35.6277 33.75 36.125V39.0988L38.0475 34.7975C38.2219 34.6235 38.429 34.4856 38.6568 34.3916C38.8845 34.2977 39.1286 34.2496 39.375 34.25H50.625C52.1168 34.25 53.5476 33.6574 54.6025 32.6025C55.6574 31.5476 56.25 30.1168 56.25 28.625V9.875C56.25 8.38316 55.6574 6.95242 54.6025 5.89752C53.5476 4.84263 52.1168 4.25 50.625 4.25H24.375C22.8832 4.25 21.4524 4.84263 20.3975 5.89752C19.3426 6.95242 18.75 8.38316 18.75 9.875V21.125C18.75 21.6223 18.5525 22.0992 18.2008 22.4508C17.8492 22.8025 17.3723 23 16.875 23C16.3777 23 15.9008 22.8025 15.5492 22.4508C15.1975 22.0992 15 21.6223 15 21.125V9.875C15 7.3886 15.9877 5.00403 17.7459 3.24587C19.504 1.48772 21.8886 0.5 24.375 0.5L50.625 0.5C53.1114 0.5 55.496 1.48772 57.2541 3.24587C59.0123 5.00403 60 7.3886 60 9.875ZM30.5475 23.5475L38.5988 15.5H31.875C31.3777 15.5 30.9008 15.3025 30.5492 14.9508C30.1975 14.5992 30 14.1223 30 13.625C30 13.1277 30.1975 12.6508 30.5492 12.2992C30.9008 11.9475 31.3777 11.75 31.875 11.75H43.125C43.3708 11.7501 43.6141 11.7985 43.8413 11.8925C44.3001 12.0849 44.6651 12.4499 44.8575 12.9088C44.9515 13.1359 44.9999 13.3792 45 13.625V24.875C45 25.3723 44.8025 25.8492 44.4508 26.2008C44.0992 26.5525 43.6223 26.75 43.125 26.75C42.6277 26.75 42.1508 26.5525 41.7992 26.2008C41.4475 25.8492 41.25 25.3723 41.25 24.875V18.1512L33.2025 26.2025C33.0281 26.3765 32.821 26.5144 32.5932 26.6084C32.3655 26.7023 32.1214 26.7504 31.875 26.75C31.6286 26.7504 31.3845 26.7023 31.1568 26.6084C30.929 26.5144 30.7219 26.3765 30.5475 26.2025C30.3729 26.0283 30.2344 25.8214 30.1398 25.5936C30.0453 25.3658 29.9966 25.1216 29.9966 24.875C29.9966 24.6284 30.0453 24.3842 30.1398 24.1564C30.2344 23.9286 30.3729 23.7217 30.5475 23.5475Z"
                              fill="#FEE069"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1512_21220">
                              <rect
                                width="60"
                                height="60"
                                fill="white"
                                transform="translate(0 0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className="info">
                        <div className="type">
                          <span>Request Date</span>
                        </div>
                        <div className="content">
                          <span>{`${moment(
                            new Date(rowData && rowData.requestOn)
                          ).format("D MMM, YYYY")}`}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="item">
                      <div className="icon">
                        <svg
                          width="48"
                          height="49"
                          viewBox="0 0 60 61"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.125 15.5C17.6277 15.5 17.1508 15.6975 16.7992 16.0492C16.4475 16.4008 16.25 16.8777 16.25 17.375V36.125C16.25 36.6223 16.4475 37.0992 16.7992 37.4508C17.1508 37.8025 17.6277 38 18.125 38C18.6223 38 19.0992 37.8025 19.4508 37.4508C19.8025 37.0992 20 36.6223 20 36.125V17.375C20 16.8777 19.8025 16.4008 19.4508 16.0492C19.0992 15.6975 18.6223 15.5 18.125 15.5ZM30 15.5C29.5027 15.5 29.0258 15.6975 28.6742 16.0492C28.3225 16.4008 28.125 16.8777 28.125 17.375V28.625C28.125 29.1223 28.3225 29.5992 28.6742 29.9508C29.0258 30.3025 29.5027 30.5 30 30.5C30.4973 30.5 30.9742 30.3025 31.3258 29.9508C31.6775 29.5992 31.875 29.1223 31.875 28.625V17.375C31.875 16.8777 31.6775 16.4008 31.3258 16.0492C30.9742 15.6975 30.4973 15.5 30 15.5ZM40 17.375C40 16.8777 40.1975 16.4008 40.5492 16.0492C40.9008 15.6975 41.3777 15.5 41.875 15.5C42.3723 15.5 42.8492 15.6975 43.2008 16.0492C43.5525 16.4008 43.75 16.8777 43.75 17.375V41.125C43.75 41.6223 43.5525 42.0992 43.2008 42.4508C42.8492 42.8025 42.3723 43 41.875 43C41.3777 43 40.9008 42.8025 40.5492 42.4508C40.1975 42.0992 40 41.6223 40 41.125V17.375Z"
                            fill="#FEE069"
                          />
                          <path
                            fillRule="evenodd"
                            clip-rule="evenodd"
                            d="M9.375 5.5C8.21468 5.5 7.10188 5.96094 6.28141 6.78141C5.46094 7.60188 5 8.71468 5 9.875V51.125C5 53.54 6.96 55.5 9.375 55.5H50.625C51.7853 55.5 52.8981 55.0391 53.7186 54.2186C54.5391 53.3981 55 52.2853 55 51.125V9.875C55 8.71468 54.5391 7.60188 53.7186 6.78141C52.8981 5.96094 51.7853 5.5 50.625 5.5H9.375ZM8.75 9.875C8.75 9.70924 8.81585 9.55027 8.93306 9.43306C9.05027 9.31585 9.20924 9.25 9.375 9.25H50.625C50.7908 9.25 50.9497 9.31585 51.0669 9.43306C51.1842 9.55027 51.25 9.70924 51.25 9.875V51.125C51.25 51.2908 51.1842 51.4497 51.0669 51.5669C50.9497 51.6842 50.7908 51.75 50.625 51.75H9.375C9.20924 51.75 9.05027 51.6842 8.93306 51.5669C8.81585 51.4497 8.75 51.2908 8.75 51.125V9.875Z"
                            fill="#FEE069"
                          />
                        </svg>
                      </div>
                      <div className="info">
                        <div className="type">
                          <span>Project</span>
                        </div>
                        <div className="content">
                          <span>{rowData && rowData.project}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="item">
                      <div className="icon">
                        <svg
                          width="48"
                          height="48"
                          viewBox="0 0 60 60"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            opacity="0.34"
                            d="M12.5 25H17.5C22.5 25 25 22.5 25 17.5V12.5C25 7.5 22.5 5 17.5 5H12.5C7.5 5 5 7.5 5 12.5V17.5C5 22.5 7.5 25 12.5 25Z"
                            stroke="#FEE069"
                            stroke-width="4"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M42.5 25H47.5C52.5 25 55 22.5 55 17.5V12.5C55 7.5 52.5 5 47.5 5H42.5C37.5 5 35 7.5 35 12.5V17.5C35 22.5 37.5 25 42.5 25Z"
                            stroke="#FEE069"
                            stroke-width="4"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            opacity="0.34"
                            d="M42.5 55H47.5C52.5 55 55 52.5 55 47.5V42.5C55 37.5 52.5 35 47.5 35H42.5C37.5 35 35 37.5 35 42.5V47.5C35 52.5 37.5 55 42.5 55Z"
                            stroke="#FEE069"
                            stroke-width="4"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12.5 55H17.5C22.5 55 25 52.5 25 47.5V42.5C25 37.5 22.5 35 17.5 35H12.5C7.5 35 5 37.5 5 42.5V47.5C5 52.5 7.5 55 12.5 55Z"
                            stroke="#FEE069"
                            stroke-width="4"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="info">
                        <div className="type">
                          <span>Module</span>
                        </div>
                        <div className="content">
                          <span>{rowData && rowData.module}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-5">
                  <div className="col-lg-4">
                    <div className="item">
                      <div className="icon">
                        <svg
                          width="48"
                          height="49"
                          viewBox="0 0 60 61"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M35 48.7142L39.5 53L50 43M10 53C10 43.335 17.835 35.5 27.5 35.5C31.218 35.5 34.6655 36.6595 37.5 38.6367M37.5 18C37.5 23.5229 33.0228 28 27.5 28C21.9771 28 17.5 23.5229 17.5 18C17.5 12.4771 21.9771 8 27.5 8C33.0228 8 37.5 12.4771 37.5 18Z"
                            stroke="#FEE069"
                            stroke-width="5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="info">
                        <div className="type">
                          <span>Assignee</span>
                        </div>
                        <div className="content">
                          <span>{rowData && rowData.assignee}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="item">
                      <div className="icon">
                        <svg
                          width="48"
                          height="49"
                          viewBox="0 0 60 61"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_1512_21220)">
                            <path
                              d="M18.75 41.75C20.7391 41.75 22.6468 40.9598 24.0533 39.5533C25.4598 38.1468 26.25 36.2391 26.25 34.25C26.25 32.2609 25.4598 30.3532 24.0533 28.9467C22.6468 27.5402 20.7391 26.75 18.75 26.75C16.7609 26.75 14.8532 27.5402 13.4467 28.9467C12.0402 30.3532 11.25 32.2609 11.25 34.25C11.25 36.2391 12.0402 38.1468 13.4467 39.5533C14.8532 40.9598 16.7609 41.75 18.75 41.75ZM18.75 30.5C19.7446 30.5 20.6984 30.8951 21.4017 31.5984C22.1049 32.3016 22.5 33.2554 22.5 34.25C22.5 35.2446 22.1049 36.1984 21.4017 36.9016C20.6984 37.6049 19.7446 38 18.75 38C17.7554 38 16.8016 37.6049 16.0983 36.9016C15.3951 36.1984 15 35.2446 15 34.25C15 33.2554 15.3951 32.3016 16.0983 31.5984C16.8016 30.8951 17.7554 30.5 18.75 30.5ZM28.125 45.5H9.375C6.8886 45.5 4.50403 46.4877 2.74587 48.2459C0.98772 50.004 0 52.3886 0 54.875C0 56.3668 0.592635 57.7976 1.64753 58.8525C2.70242 59.9074 4.13316 60.5 5.625 60.5H31.875C33.3668 60.5 34.7976 59.9074 35.8525 58.8525C36.9074 57.7976 37.5 56.3668 37.5 54.875C37.5 52.3886 36.5123 50.004 34.7541 48.2459C32.996 46.4877 30.6114 45.5 28.125 45.5ZM31.875 56.75H5.625C5.12772 56.75 4.6508 56.5525 4.29917 56.2008C3.94754 55.8492 3.75 55.3723 3.75 54.875C3.75 53.3832 4.34264 51.9524 5.39753 50.8975C6.45242 49.8426 7.88316 49.25 9.375 49.25H28.125C29.6168 49.25 31.0476 49.8426 32.1025 50.8975C33.1574 51.9524 33.75 53.3832 33.75 54.875C33.75 55.3723 33.5525 55.8492 33.2008 56.2008C32.8492 56.5525 32.3723 56.75 31.875 56.75ZM60 9.875V28.625C60 31.1114 59.0123 33.496 57.2541 35.2541C55.496 37.0123 53.1114 38 50.625 38H40.1512L33.2025 44.9525C33.0281 45.1265 32.821 45.2644 32.5932 45.3584C32.3655 45.4523 32.1214 45.5004 31.875 45.5C31.6292 45.5006 31.3857 45.4522 31.1588 45.3575C30.8159 45.2158 30.5227 44.9755 30.3165 44.6671C30.1102 44.3587 30.0001 43.996 30 43.625V36.125C30 35.6277 30.1975 35.1508 30.5492 34.7992C30.9008 34.4475 31.3777 34.25 31.875 34.25C32.3723 34.25 32.8492 34.4475 33.2008 34.7992C33.5525 35.1508 33.75 35.6277 33.75 36.125V39.0988L38.0475 34.7975C38.2219 34.6235 38.429 34.4856 38.6568 34.3916C38.8845 34.2977 39.1286 34.2496 39.375 34.25H50.625C52.1168 34.25 53.5476 33.6574 54.6025 32.6025C55.6574 31.5476 56.25 30.1168 56.25 28.625V9.875C56.25 8.38316 55.6574 6.95242 54.6025 5.89752C53.5476 4.84263 52.1168 4.25 50.625 4.25H24.375C22.8832 4.25 21.4524 4.84263 20.3975 5.89752C19.3426 6.95242 18.75 8.38316 18.75 9.875V21.125C18.75 21.6223 18.5525 22.0992 18.2008 22.4508C17.8492 22.8025 17.3723 23 16.875 23C16.3777 23 15.9008 22.8025 15.5492 22.4508C15.1975 22.0992 15 21.6223 15 21.125V9.875C15 7.3886 15.9877 5.00403 17.7459 3.24587C19.504 1.48772 21.8886 0.5 24.375 0.5L50.625 0.5C53.1114 0.5 55.496 1.48772 57.2541 3.24587C59.0123 5.00403 60 7.3886 60 9.875ZM30.5475 23.5475L38.5988 15.5H31.875C31.3777 15.5 30.9008 15.3025 30.5492 14.9508C30.1975 14.5992 30 14.1223 30 13.625C30 13.1277 30.1975 12.6508 30.5492 12.2992C30.9008 11.9475 31.3777 11.75 31.875 11.75H43.125C43.3708 11.7501 43.6141 11.7985 43.8413 11.8925C44.3001 12.0849 44.6651 12.4499 44.8575 12.9088C44.9515 13.1359 44.9999 13.3792 45 13.625V24.875C45 25.3723 44.8025 25.8492 44.4508 26.2008C44.0992 26.5525 43.6223 26.75 43.125 26.75C42.6277 26.75 42.1508 26.5525 41.7992 26.2008C41.4475 25.8492 41.25 25.3723 41.25 24.875V18.1512L33.2025 26.2025C33.0281 26.3765 32.821 26.5144 32.5932 26.6084C32.3655 26.7023 32.1214 26.7504 31.875 26.75C31.6286 26.7504 31.3845 26.7023 31.1568 26.6084C30.929 26.5144 30.7219 26.3765 30.5475 26.2025C30.3729 26.0283 30.2344 25.8214 30.1398 25.5936C30.0453 25.3658 29.9966 25.1216 29.9966 24.875C29.9966 24.6284 30.0453 24.3842 30.1398 24.1564C30.2344 23.9286 30.3729 23.7217 30.5475 23.5475Z"
                              fill="#FEE069"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1512_21220">
                              <rect
                                width="60"
                                height="60"
                                fill="white"
                                transform="translate(0 0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className="info">
                        <div className="type">
                          <span>Duration</span>
                        </div>
                        <div className="content">
                          <span>{rowData && rowData.workduration} Days</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="item">
                      <div className="icon">
                        <svg
                          width="48"
                          height="49"
                          viewBox="0 0 60 61"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.125 15.5C17.6277 15.5 17.1508 15.6975 16.7992 16.0492C16.4475 16.4008 16.25 16.8777 16.25 17.375V36.125C16.25 36.6223 16.4475 37.0992 16.7992 37.4508C17.1508 37.8025 17.6277 38 18.125 38C18.6223 38 19.0992 37.8025 19.4508 37.4508C19.8025 37.0992 20 36.6223 20 36.125V17.375C20 16.8777 19.8025 16.4008 19.4508 16.0492C19.0992 15.6975 18.6223 15.5 18.125 15.5ZM30 15.5C29.5027 15.5 29.0258 15.6975 28.6742 16.0492C28.3225 16.4008 28.125 16.8777 28.125 17.375V28.625C28.125 29.1223 28.3225 29.5992 28.6742 29.9508C29.0258 30.3025 29.5027 30.5 30 30.5C30.4973 30.5 30.9742 30.3025 31.3258 29.9508C31.6775 29.5992 31.875 29.1223 31.875 28.625V17.375C31.875 16.8777 31.6775 16.4008 31.3258 16.0492C30.9742 15.6975 30.4973 15.5 30 15.5ZM40 17.375C40 16.8777 40.1975 16.4008 40.5492 16.0492C40.9008 15.6975 41.3777 15.5 41.875 15.5C42.3723 15.5 42.8492 15.6975 43.2008 16.0492C43.5525 16.4008 43.75 16.8777 43.75 17.375V41.125C43.75 41.6223 43.5525 42.0992 43.2008 42.4508C42.8492 42.8025 42.3723 43 41.875 43C41.3777 43 40.9008 42.8025 40.5492 42.4508C40.1975 42.0992 40 41.6223 40 41.125V17.375Z"
                            fill="#FEE069"
                          />
                          <path
                            fillRule="evenodd"
                            clip-rule="evenodd"
                            d="M9.375 5.5C8.21468 5.5 7.10188 5.96094 6.28141 6.78141C5.46094 7.60188 5 8.71468 5 9.875V51.125C5 53.54 6.96 55.5 9.375 55.5H50.625C51.7853 55.5 52.8981 55.0391 53.7186 54.2186C54.5391 53.3981 55 52.2853 55 51.125V9.875C55 8.71468 54.5391 7.60188 53.7186 6.78141C52.8981 5.96094 51.7853 5.5 50.625 5.5H9.375ZM8.75 9.875C8.75 9.70924 8.81585 9.55027 8.93306 9.43306C9.05027 9.31585 9.20924 9.25 9.375 9.25H50.625C50.7908 9.25 50.9497 9.31585 51.0669 9.43306C51.1842 9.55027 51.25 9.70924 51.25 9.875V51.125C51.25 51.2908 51.1842 51.4497 51.0669 51.5669C50.9497 51.6842 50.7908 51.75 50.625 51.75H9.375C9.20924 51.75 9.05027 51.6842 8.93306 51.5669C8.81585 51.4497 8.75 51.2908 8.75 51.125V9.875Z"
                            fill="#FEE069"
                          />
                        </svg>
                      </div>
                      <div className="info">
                        <div className="type">
                          <span>Working hours</span>
                        </div>
                        <div className="content">
                          <span>{rowData && rowData.workinghrs} Hours</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {rowData && Array.isArray(rowData.reqdetails)
                  ? rowData.reqdetails.map((item) => {
                      return (
                        <>
                          <div className="row mb-5">
                            <div className="col-lg-3">
                              <div className="item">
                                <div className="icon">
                                  <svg
                                    width="60"
                                    height="60"
                                    viewBox="0 0 60 60"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clipPath="url(#clip0_123_1753)">
                                      <path
                                        d="M60 30C60 30.663 59.7366 31.2989 59.2678 31.7678C58.7989 32.2366 58.163 32.5 57.5 32.5C56.837 32.5 56.2011 32.2366 55.7322 31.7678C55.2634 31.2989 55 30.663 55 30C54.9927 23.3718 52.3565 17.0172 47.6696 12.3304C42.9828 7.64354 36.6282 5.00728 30 5C29.337 5 28.7011 4.73661 28.2322 4.26777C27.7634 3.79893 27.5 3.16304 27.5 2.5C27.5 1.83696 27.7634 1.20107 28.2322 0.732233C28.7011 0.263392 29.337 0 30 0C37.9539 0.0086027 45.5795 3.17207 51.2037 8.7963C56.8279 14.4205 59.9914 22.0461 60 30ZM40 32.5C40.663 32.5 41.2989 32.2366 41.7678 31.7678C42.2366 31.2989 42.5 30.663 42.5 30C42.5 29.337 42.2366 28.7011 41.7678 28.2322C41.2989 27.7634 40.663 27.5 40 27.5H34.3075C33.8718 26.7511 33.2489 26.1282 32.5 25.6925V17.5C32.5 16.837 32.2366 16.2011 31.7678 15.7322C31.2989 15.2634 30.663 15 30 15C29.337 15 28.7011 15.2634 28.2322 15.7322C27.7634 16.2011 27.5 16.837 27.5 17.5V25.6925C26.8369 26.0743 26.2706 26.6036 25.845 27.2394C25.4194 27.8752 25.1458 28.6005 25.0455 29.359C24.9452 30.1175 25.0208 30.8889 25.2665 31.6135C25.5123 32.3381 25.9215 32.9964 26.4625 33.5375C27.0036 34.0785 27.6619 34.4877 28.3865 34.7335C29.1111 34.9792 29.8825 35.0548 30.641 34.9545C31.3995 34.8542 32.1248 34.5806 32.7606 34.155C33.3964 33.7294 33.9257 33.1631 34.3075 32.5H40ZM4.5675 16.96C4.07305 16.96 3.5897 17.1066 3.17858 17.3813C2.76745 17.656 2.44702 18.0465 2.2578 18.5033C2.06858 18.9601 2.01907 19.4628 2.11554 19.9477C2.212 20.4327 2.4501 20.8781 2.79973 21.2278C3.14937 21.5774 3.59482 21.8155 4.07978 21.912C4.56473 22.0084 5.06739 21.9589 5.52421 21.7697C5.98103 21.5805 6.37147 21.26 6.64618 20.8489C6.92088 20.4378 7.0675 19.9545 7.0675 19.46C7.0675 18.797 6.80411 18.1611 6.33527 17.6922C5.86643 17.2234 5.23054 16.96 4.5675 16.96ZM5 30C5 29.5055 4.85338 29.0222 4.57868 28.6111C4.30397 28.2 3.91352 27.8795 3.45671 27.6903C2.99989 27.5011 2.49723 27.4516 2.01228 27.548C1.52732 27.6445 1.08187 27.8826 0.732234 28.2322C0.382603 28.5819 0.144501 29.0273 0.0480379 29.5123C-0.0484251 29.9972 0.0010832 30.4999 0.190302 30.9567C0.379521 31.4135 0.699953 31.804 1.11108 32.0787C1.5222 32.3534 2.00555 32.5 2.5 32.5C3.16304 32.5 3.79893 32.2366 4.26777 31.7678C4.73661 31.2989 5 30.663 5 30ZM30 55C29.5055 55 29.0222 55.1466 28.6111 55.4213C28.2 55.696 27.8795 56.0865 27.6903 56.5433C27.5011 57.0001 27.4516 57.5028 27.548 57.9877C27.6445 58.4727 27.8826 58.9181 28.2322 59.2678C28.5819 59.6174 29.0273 59.8555 29.5123 59.952C29.9972 60.0484 30.4999 59.9989 30.9567 59.8097C31.4135 59.6205 31.804 59.3 32.0787 58.8889C32.3534 58.4778 32.5 57.9945 32.5 57.5C32.5 56.837 32.2366 56.2011 31.7678 55.7322C31.2989 55.2634 30.663 55 30 55ZM10.5525 8.0175C10.058 8.0175 9.5747 8.16412 9.16358 8.43883C8.75245 8.71353 8.43202 9.10398 8.2428 9.56079C8.05358 10.0176 8.00408 10.5203 8.10054 11.0052C8.197 11.4902 8.4351 11.9356 8.78473 12.2853C9.13437 12.6349 9.57982 12.873 10.0648 12.9695C10.5497 13.0659 11.0524 13.0164 11.5092 12.8272C11.966 12.638 12.3565 12.3175 12.6312 11.9064C12.9059 11.4953 13.0525 11.012 13.0525 10.5175C13.0525 9.85446 12.7891 9.21857 12.3203 8.74973C11.8514 8.28089 11.2155 8.0175 10.5525 8.0175ZM19.4475 2.1025C18.953 2.1025 18.4697 2.24912 18.0586 2.52383C17.6475 2.79853 17.327 3.18898 17.1378 3.64579C16.9486 4.10261 16.8991 4.60527 16.9955 5.09023C17.092 5.57518 17.3301 6.02064 17.6797 6.37027C18.0294 6.7199 18.4748 6.958 18.9598 7.05446C19.4447 7.15093 19.9474 7.10142 20.4042 6.9122C20.861 6.72298 21.2515 6.40255 21.5262 5.99143C21.8009 5.5803 21.9475 5.09695 21.9475 4.6025C21.9475 3.93946 21.6841 3.30357 21.2153 2.83473C20.7464 2.36589 20.1105 2.1025 19.4475 2.1025ZM4.5675 38.04C4.07305 38.04 3.5897 38.1866 3.17858 38.4613C2.76745 38.736 2.44702 39.1265 2.2578 39.5833C2.06858 40.0401 2.01907 40.5428 2.11554 41.0277C2.212 41.5127 2.4501 41.9581 2.79973 42.3078C3.14937 42.6574 3.59482 42.8955 4.07978 42.992C4.56473 43.0884 5.06739 43.0389 5.52421 42.8497C5.98103 42.6605 6.37147 42.34 6.64618 41.9289C6.92088 41.5178 7.0675 41.0345 7.0675 40.54C7.0675 39.877 6.80411 39.2411 6.33527 38.7722C5.86643 38.3034 5.23054 38.04 4.5675 38.04ZM10.5525 46.9825C10.058 46.9825 9.5747 47.1291 9.16358 47.4038C8.75245 47.6785 8.43202 48.069 8.2428 48.5258C8.05358 48.9826 8.00408 49.4853 8.10054 49.9702C8.197 50.4552 8.4351 50.9006 8.78473 51.2503C9.13437 51.5999 9.57982 51.838 10.0648 51.9345C10.5497 52.0309 11.0524 51.9814 11.5092 51.7922C11.966 51.603 12.3565 51.2825 12.6312 50.8714C12.9059 50.4603 13.0525 49.977 13.0525 49.4825C13.0525 48.8195 12.7891 48.1836 12.3203 47.7147C11.8514 47.2459 11.2155 46.9825 10.5525 46.9825ZM19.4475 52.8975C18.953 52.8975 18.4697 53.0441 18.0586 53.3188C17.6475 53.5935 17.327 53.984 17.1378 54.4408C16.9486 54.8976 16.8991 55.4003 16.9955 55.8852C17.092 56.3702 17.3301 56.8156 17.6797 57.1653C18.0294 57.5149 18.4748 57.753 18.9598 57.8495C19.4447 57.9459 19.9474 57.8964 20.4042 57.7072C20.861 57.518 21.2515 57.1976 21.5262 56.7864C21.8009 56.3753 21.9475 55.892 21.9475 55.3975C21.9475 54.7345 21.6841 54.0986 21.2153 53.6297C20.7464 53.1609 20.1105 52.8975 19.4475 52.8975ZM55.4325 38.04C54.938 38.04 54.4547 38.1866 54.0436 38.4613C53.6325 38.736 53.312 39.1265 53.1228 39.5833C52.9336 40.0401 52.8841 40.5428 52.9805 41.0277C53.077 41.5127 53.3151 41.9581 53.6647 42.3078C54.0144 42.6574 54.4598 42.8955 54.9448 42.992C55.4297 43.0884 55.9324 43.0389 56.3892 42.8497C56.846 42.6605 57.2365 42.34 57.5112 41.9289C57.7859 41.5178 57.9325 41.0345 57.9325 40.54C57.9325 40.2117 57.8678 39.8866 57.7422 39.5833C57.6166 39.28 57.4324 39.0044 57.2003 38.7722C56.9681 38.5401 56.6925 38.3559 56.3892 38.2303C56.0859 38.1047 55.7608 38.04 55.4325 38.04ZM49.4475 46.9825C48.953 46.9825 48.4697 47.1291 48.0586 47.4038C47.6475 47.6785 47.327 48.069 47.1378 48.5258C46.9486 48.9826 46.8991 49.4853 46.9955 49.9702C47.092 50.4552 47.3301 50.9006 47.6797 51.2503C48.0294 51.5999 48.4748 51.838 48.9598 51.9345C49.4447 52.0309 49.9474 51.9814 50.4042 51.7922C50.861 51.603 51.2515 51.2825 51.5262 50.8714C51.8009 50.4603 51.9475 49.977 51.9475 49.4825C51.9475 49.1542 51.8828 48.8291 51.7572 48.5258C51.6316 48.2225 51.4474 47.9469 51.2153 47.7147C50.9831 47.4826 50.7075 47.2984 50.4042 47.1728C50.1009 47.0472 49.7758 46.9825 49.4475 46.9825ZM40.5525 52.8975C40.058 52.8975 39.5747 53.0441 39.1636 53.3188C38.7525 53.5935 38.432 53.984 38.2428 54.4408C38.0536 54.8976 38.0041 55.4003 38.1005 55.8852C38.197 56.3702 38.4351 56.8156 38.7847 57.1653C39.1344 57.5149 39.5798 57.753 40.0648 57.8495C40.5497 57.9459 41.0524 57.8964 41.5092 57.7072C41.966 57.518 42.3565 57.1976 42.6312 56.7864C42.9059 56.3753 43.0525 55.892 43.0525 55.3975C43.0525 55.0692 42.9878 54.7441 42.8622 54.4408C42.7366 54.1375 42.5524 53.8619 42.3203 53.6297C42.0881 53.3976 41.8125 53.2134 41.5092 53.0878C41.2059 52.9622 40.8808 52.8975 40.5525 52.8975Z"
                                        fill="#0EB9D7"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_123_1753">
                                        <rect
                                          width="60"
                                          height="60"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </div>
                                <div className="info flex">
                                  <div className="type">
                                    <span>From Time </span>
                                  </div>
                                  <div className="content">
                                    <span>{item.fromtime} Am</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="duration">
                                <div className="d-flex flex-column align-items-center">
                                  <span>{item.workinghrs} Hours</span>
                                  <div className="dotted-line">
                                    <svg
                                      width="100%"
                                      height="2"
                                      viewBox="0 0 461 2"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M461 1L-1.66893e-05 1"
                                        stroke="url(#paint0_linear_123_1778)"
                                        strokeWidth="2"
                                        strokeDasharray="5 5"
                                      />
                                      <defs>
                                        <linearGradient
                                          id="paint0_linear_123_1778"
                                          x1="0"
                                          y1="0.5"
                                          x2="461"
                                          y2="0.5"
                                          gradientUnits="userSpaceOnUse"
                                        >
                                          <stop stopColor="#3B82F6" />
                                          <stop
                                            offset="1"
                                            stopColor="#EF0B0B"
                                          />
                                        </linearGradient>
                                      </defs>
                                    </svg>
                                  </div>
                                  <span>{`${moment(
                                    item && item.rdate,
                                    "YYYY-MM-DD"
                                  ).format("DD MMMM YYYY")}`}</span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="item">
                                <div className="icon">
                                  <svg
                                    width="60"
                                    height="61"
                                    viewBox="0 0 60 61"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clipPath="url(#clip0_123_1747)">
                                      <path
                                        d="M60 30.5C60 38.4565 56.8393 46.0871 51.2132 51.7132C45.5871 57.3393 37.9565 60.5 30 60.5C22.0435 60.5 14.4129 57.3393 8.7868 51.7132C3.16071 46.0871 0 38.4565 0 30.5C0 29.837 0.263392 29.2011 0.732233 28.7322C1.20107 28.2634 1.83696 28 2.5 28C3.16304 28 3.79893 28.2634 4.26777 28.7322C4.73661 29.2011 5 29.837 5 30.5C5 35.4445 6.46622 40.278 9.21326 44.3893C11.9603 48.5005 15.8648 51.7048 20.4329 53.597C25.0011 55.4892 30.0277 55.9843 34.8773 55.0196C39.7268 54.055 44.1814 51.674 47.6777 48.1777C51.174 44.6814 53.555 40.2268 54.5196 35.3773C55.4843 30.5277 54.9892 25.5011 53.097 20.9329C51.2048 16.3648 48.0005 12.4603 43.8893 9.71326C39.778 6.96622 34.9445 5.5 30 5.5C29.337 5.5 28.7011 5.23661 28.2322 4.76777C27.7634 4.29893 27.5 3.66304 27.5 3C27.5 2.33696 27.7634 1.70107 28.2322 1.23223C28.7011 0.763392 29.337 0.5 30 0.5C37.9539 0.508603 45.5795 3.67207 51.2037 9.2963C56.8279 14.9205 59.9914 22.5461 60 30.5ZM25.6925 28H20C19.337 28 18.7011 28.2634 18.2322 28.7322C17.7634 29.2011 17.5 29.837 17.5 30.5C17.5 31.163 17.7634 31.7989 18.2322 32.2678C18.7011 32.7366 19.337 33 20 33H25.6925C26.0743 33.6631 26.6036 34.2294 27.2394 34.655C27.8752 35.0806 28.6005 35.3542 29.359 35.4545C30.1175 35.5548 30.8889 35.4792 31.6135 35.2335C32.3381 34.9877 32.9964 34.5785 33.5375 34.0375C34.0785 33.4964 34.4877 32.8381 34.7335 32.1135C34.9792 31.3889 35.0548 30.6175 34.9545 29.859C34.8542 29.1005 34.5806 28.3752 34.155 27.7394C33.7294 27.1036 33.1631 26.5743 32.5 26.1925V18C32.5 17.337 32.2366 16.7011 31.7678 16.2322C31.2989 15.7634 30.663 15.5 30 15.5C29.337 15.5 28.7011 15.7634 28.2322 16.2322C27.7634 16.7011 27.5 17.337 27.5 18V26.1925C26.7511 26.6282 26.1282 27.2511 25.6925 28ZM4.5675 22.46C5.06195 22.46 5.5453 22.3134 5.95643 22.0387C6.36755 21.764 6.68798 21.3735 6.8772 20.9167C7.06642 20.4599 7.11593 19.9572 7.01946 19.4723C6.923 18.9873 6.6849 18.5419 6.33527 18.1922C5.98564 17.8426 5.54018 17.6045 5.05523 17.508C4.57027 17.4116 4.06761 17.4611 3.61079 17.6503C3.15398 17.8395 2.76353 18.16 2.48883 18.5711C2.21412 18.9822 2.0675 19.4655 2.0675 19.96C2.0675 20.623 2.33089 21.2589 2.79973 21.7278C3.26857 22.1966 3.90446 22.46 4.5675 22.46ZM10.5525 13.5175C11.047 13.5175 11.5303 13.3709 11.9414 13.0962C12.3525 12.8215 12.673 12.431 12.8622 11.9742C13.0514 11.5174 13.1009 11.0147 13.0045 10.5298C12.908 10.0448 12.6699 9.59936 12.3203 9.24973C11.9706 8.9001 11.5252 8.662 11.0402 8.56554C10.5553 8.46907 10.0526 8.51858 9.59579 8.7078C9.13898 8.89702 8.74853 9.21745 8.47383 9.62857C8.19912 10.0397 8.0525 10.523 8.0525 11.0175C8.0525 11.6805 8.31589 12.3164 8.78473 12.7853C9.25357 13.2541 9.88946 13.5175 10.5525 13.5175ZM19.4475 7.6025C19.942 7.6025 20.4253 7.45588 20.8364 7.18117C21.2475 6.90647 21.568 6.51602 21.7572 6.05921C21.9464 5.60239 21.9959 5.09973 21.8995 4.61477C21.803 4.12982 21.5649 3.68436 21.2153 3.33473C20.8656 2.9851 20.4202 2.747 19.9352 2.65054C19.4503 2.55407 18.9476 2.60358 18.4908 2.7928C18.034 2.98202 17.6435 3.30245 17.3688 3.71357C17.0941 4.1247 16.9475 4.60805 16.9475 5.1025C16.9475 5.76554 17.2109 6.40143 17.6797 6.87027C18.1486 7.33911 18.7845 7.6025 19.4475 7.6025Z"
                                        fill="#F63C3C"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_123_1747">
                                        <rect
                                          width="60"
                                          height="60"
                                          fill="white"
                                          transform="translate(0 0.5)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </div>
                                <div className="info">
                                  <div className="type">
                                    <span>To Time</span>
                                  </div>
                                  <div className="content">
                                    <span>{item.totime} PM</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-2">
                              <button
                                className="btn btn-primary"
                                onClick={() =>
                                  handleShowModal(item.rdate, item.requestid)
                                }
                                disabled={
                                  approvalStatus !== "Approved" ||
                                  rowData.empid !== user.empid
                                }
                              >
                                Log Hours
                              </button>
                            </div>
                          </div>
                        </>
                      );
                    })
                  : null}
              </div>
              <div className="heading">
                <span>Remark</span>
              </div>
              <div className="remark">
                <div
                  dangerouslySetInnerHTML={{ __html: rowData.description }}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="approval-status2 recent-leave">
              <div className="approval-status">
                <div className="first-approval">
                  <div className="profile">
                    {approvalHierarchy[0].profile &&
                    approvalHierarchy[0].profile ? (
                      <img src={TeamLead} width={50} alt="" />
                    ) : (
                      <>
                        <div className="circle">
                          <span>{getNameInitials(approvalHierarchy && approvalHierarchy[0].name)}</span>
                        </div>
                      </>
                    )}

                    <span className="name">{approvalHierarchy[0].name}</span>
                    <span className="desig">RM</span>
                  </div>
                  {rowData && rowData.rM_isapproved === "0" ? (
                    <>
                      <div className="status">
                        <span className="pending">Approval Pending</span>
                      </div>
                    </>
                  ) : rowData && rowData.rM_isapproved === "1" ? (
                    <>
                      <div className="status d-flex flex-column gap-2">
                        <span className="approved">
                          Approved at {rowData.rM_ActionOn}
                        </span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="status d-flex flex-column gap-2">
                        <span>
                          <img src={RedCross} width={30} alt="" />
                        </span>
                        <span className="rejected">Approval Rejected</span>
                      </div>
                    </>
                  )}
                </div>
                {rowData &&
                (user.role !== "1" || location.pathname !== "/leaveDetails") ? (
                  <>
                    <div className="process">
                      {rowData.rM_isapproved === "0" &&
                      rowData.hR_isapproved === "0" ? (
                        <>
                          <span className="">
                            <img src={DashedArrow} height={250} alt="" />
                          </span>
                          <div className="approvalTime">
                            <span>
                              <img src={TimeIcon} width={40} alt="" />
                            </span>
                          </div>
                        </>
                      ) : rowData.rM_isapproved === "1" &&
                        rowData.hR_isapproved === "0" ? (
                        <>
                          <div className="process-flex flex-column">
                            <span>
                              <img src={GreenCheck} width={30} alt="" />
                            </span>
                            <span className="">
                              <img
                                src={PartiallyApprovedDashedArrow}
                                height={250}
                                alt=""
                              />
                            </span>
                            <div className="approvalTime">
                              <span>
                                <img src={TimeIcon} width={40} alt="" />
                              </span>
                            </div>
                          </div>
                        </>
                      ) : rowData.rM_isapproved === "1" ||
                        rowData.hR_isapproved === "1" ? (
                        <>
                          <span className="">
                            <img
                              src={ApprovedDashedArrow}
                              height={250}
                              alt=""
                            />
                          </span>
                          <div className="approvalTime">
                            <span>
                              <img src={GreenCheck} width={30} alt="" />
                            </span>
                          </div>
                        </>
                      ) : rowData.rM_isapproved === "2" ||
                        rowData.hR_isapproved === "0" ? (
                        <>
                          <div className="process-flex flex-column">
                            <span className="">
                              <img
                                src={partiallyRejectedDashedArrow}
                                height={250}
                                alt=""
                              />
                            </span>
                          </div>

                          <div className="approvalTime">
                            <span>
                              <img src={RedCross} width={30} alt="" />
                            </span>
                          </div>
                        </>
                      ) : rowData.rM_isapproved === "2" ||
                        rowData.hR_isapproved === "2" ? (
                        <>
                          <span className="">
                            <img
                              src={RejectedDashedArrow}
                              height={250}
                              alt=""
                            />
                          </span>

                          <div className="approvalTime">
                            <span>
                              <img src={RedCross} width={30} alt="" />
                            </span>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="last-approval">
                      {rowData.hR_isapproved === "0" ? (
                        <>
                          <div className="status">
                            <span className="pending">Approval Pending</span>
                          </div>
                        </>
                      ) : rowData.hR_isapproved === "1" ? (
                        <>
                          <div className="status d-flex flex-column gap-2">
                            <span className="approved">
                              Approved at {rowData.hR_ActionOn}
                            </span>
                            <span>
                              <img src={GreenCheck} width={30} alt="" />
                            </span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="status d-flex flex-column gap-2">
                            <span>
                              <img src={RedCross} width={30} alt="" />
                            </span>
                            <span className="rejected">Approval Rejected</span>
                          </div>
                        </>
                      )}
                      <div className="profile">
                        {approvalHierarchy[1].profile ? (
                          <img src={TeamLead} width={50} alt="" />
                        ) : (
                          <>
                            <div className="circle">
                              {rowData.hR_ActionBy === "HR" ? (
                                <>
                                  <span>{approvalHierarchy[1].name}</span>
                                </>
                              ) : approvalHierarchy[1].name !== "" ? (
                                <>
                                <span>{getNameInitials(approvalHierarchy && approvalHierarchy[1].name)}</span>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          </>
                        )}
                        <span className="name">
                          {approvalHierarchy[1].name}
                        </span>
                        <span className="desig">HR</span>
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <div
          className={`${modalShow ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setModalShow(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div
              className={`${
                modalShow
                  ? "filterByModalNew visible"
                  : "filterByModalNew hidden"
              }`}
            >
              <div className="sort-list">
                <h4 className="mb-3">
                  Update Log for{" "}
                  <span>{`${moment(
                    updateDetails && updateDetails.rdate,
                    "YYYY-MM-DD"
                  ).format("DD MMMM YYYY")}`}</span>{" "}
                </h4>
                <Form.Group className="mb-3">
                  <Form.Label>From Time * </Form.Label>
                  <Form.Control
                    type="time"
                    name="wDfromtime"
                    required
                    value={updateDetails.wDfromtime}
                    onChange={handleInputChnage}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>To Time *</Form.Label>
                  <Form.Control
                    type="time"
                    name="wDtotime"
                    required
                    value={updateDetails.wDtotime}
                    onChange={handleInputChnage}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Working Hours </Form.Label>
                  <Form.Control
                    type="text"
                    name="wdWorkinghrs"
                    value={updateDetails.wdWorkinghrs}
                    readOnly
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Description </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="wDdescription"
                    value={updateDetails.wDdescription}
                    onChange={handleInputChnage}
                  />
                </Form.Group>
                <button
                  className="btn btn-primary"
                  type="submit"
                  onClick={handleUpdateLogs}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HolidayShiftDetails;
